import React from 'react';
import './WhatIsStreetWorkout.css';

// Force this file to be a module
export { };

const WhatIsStreetWorkout: React.FC = () => {
  return (
    <section id="what-is-street-workout" className="what-is-section section">
      <div className="what-is-container">
        <div className="what-is-content">
          <h2 className="what-is-title">甚麼是街頭健身</h2>
          <div className="what-is-text">
            <p>
              街頭健身（Calisthenics or Street Workout）是一種結合徒手訓練和極限體操的現代運動，起源於東歐及非裔美國社群。它強調使用自身體重進行鍛煉，利用公園常見的單槓、雙槓及長櫈等公共設施作為訓練場地，不需要昂貴的器材。街頭健身包括基本動作如引體向上、伏地挺身、深蹲，以及高難度的極限動作如暴力上槓、前水平等。
            </p>
            <p>
              街頭健身的動作分為靜態力量和動態花式兩大類，前者注重肌肉的靜態支撐力量，後者則考驗身體的協調性及爆炸力。這項運動在2000年代於全球迅速傳播，並有多個國際賽事，例如由世界街頭健身及徒手健身協會 WSWCF (World Street Workout & Calisthenics Federation) 舉辦的世界錦標賽。街頭健身在香港為一項新興運動，至今有大約十多年歷史，香港街頭健身總會於2014年成立並舉辦第一場本地賽事。
            </p>
          </div>
        </div>
        <div className="workout-video-container">
          {/* <iframe
            className="workout-video"
            style={{
              display: 'block', // Ensures margin auto works for centering
              margin: '0 auto',   // Centers the iframe if container is wider, top/bottom margin is 0
              maxWidth: '315px',  // Max width for a typical "Short" display
              width: '100%',      // Responsive width up to maxWidth
              aspectRatio: '9 / 16', // Sets the portrait aspect ratio
              height: '100%',     // Height adjusts based on width and aspectRatio
              border: 'none',     // Explicitly remove any iframe border
              minWidth: '400px', // Ensures a minimum width for the iframe
            }}
            src="https://www.youtube.com/embed/D3B4dTDQG4I?autoplay=1&mute=1&loop=1&playlist=D3B4dTDQG4I&rel=0&controls=0"
            title="YouTube video player"
            frameBorder="0" // Fallback for older browsers
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe> */}
          <iframe
            className="workout-video"
            style={{
              display: 'block',
              margin: '0 auto',
              maxWidth: '315px',
              width: '100%',
              aspectRatio: '9 / 16',
              height: '100%',
              border: 'none',
              minWidth: '400px',
            }}
            src="https://www.youtube.com/embed/AJwJMwScieY?autoplay=1&mute=1&loop=1&playlist=AJwJMwScieY&rel=0&controls=0"
            title="❤️‍🔥街頭健身花式技巧班｜Jay Street Workout & Calisthenics Studio"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerPolicy="strict-origin-when-cross-origin"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};

export default WhatIsStreetWorkout;
